import { RegisterItem } from '@wearejh/m2-pwa-engine/lib/types';

import { algoliaAnalyticsEpic } from './epics/algolia-analytics.epic';
import { algoliaReducer } from './reducer';

export function algoliaRegister(): RegisterItem {
    return {
        epics: [algoliaAnalyticsEpic],
        name: 'algolia',
        reducers: {
            algolia: algoliaReducer,
        },
    };
}
